type Props = {
	unit: string;
	value: string;
	separator?: string;
};

export function WeatherValue({ value, unit, separator = ' ' }: Props) {
	return (
		<>
			{value}
			{separator}
			{unit}
		</>
	);
}
